module.exports = __webpack_public_path__ + "static/media/(V)-Artesanato-15.7168d322.jpg";